import { IGenerationRules } from "./models";

export const dataOrigins = [
  {
    id: "1",
    name: "TASY",
  },
];

export const generationRuleItems: IGenerationRules[] = [
  {
    id: "100",
    name: "gerador 1",
    dataOrigin: dataOrigins[0],
  },
  {
    id: "101",
    name: "gerador 2",
    dataOrigin: dataOrigins[0],
  },
];
